// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__6B2mc","col":"Table_col__3Z5Tf","fulfillmentStatus":"Table_fulfillmentStatus__2FoIG","emailCol":"Table_emailCol__360ZX"};